export default {

  // 新增技术创新
  insertPaTechInnovation: '/ygsjzs/paTechInnovation/insertPaTechInnovation',
  // 修改技术创新
  updatePaTechInnovation: '/ygsjzs/paTechInnovation/updatePaTechInnovation',
  // 审批技术创新
  approvalPaTechInnovation: '/ygsjzs/paTechInnovation/approvalPaTechInnovation',
  // 物理删除技术创新
  deleteDataPaTechInnovation: '/ygsjzs/paTechInnovation/deleteDataPaTechInnovation',
  // 查询技术创新详情
  selectPaTechInnovationByInnovationId: '/ygsjzs/paTechInnovation/selectPaTechInnovationByInnovationId',
  // 分页查询技术创新列表
  selectPaTechInnovationByPage: '/ygsjzs/paTechInnovation/selectPaTechInnovationByPage'

}
